import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Box,
  Modal,
  FormHelperText,
} from "@mui/material";
import ComboBox from "../ComboBox";
import ComboBoxMultiSelect from "../ComboBoxMultiSelect";
import { jwtDecode } from "jwt-decode";
import PropTypes from "prop-types";
import closeIcon from "../../assets/images/closeicon.svg";
import { fieldUser } from "./FieldJson";
import AccessibleTooltip from "../Tooltip/Tooltip.js";
import checkImg from "../../assets/images/check_circle.svg";
import {
  addBuilding,
  resestMarkFeild,
  editBuliding,
  customerDataAction,
  fetchUsersFromCustomer,
  fetchBuidingPersonnelFromCustomer,
} from "../../Actions/BuildingManagementAction";
import { useDispatch, useSelector } from "react-redux";
import "./mustyle.scss";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4, 
  paddingRight: 4,
};
const AddEditBuilding = (props) => {
  const [formData, setFormData] = useState({
    customerName: "",
    customerId: "",
    location: "",
    address: "",
    latitude: "",
    longitude: "",
    locationUrl: "",
    buildingPersonnel: [],
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const token = JSON.parse(localStorage.getItem("token"));
  const decodedToken = jwtDecode(token);
  const userRole = decodedToken.userRole;
  const userGuid = decodedToken.userGuid;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const [formError, setFormError] = useState("");
  const [formLevelError, setFormLevelError] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);
  const {
    setOpen,
    open,
    actionButton,
    setActionButton,
    editData,
    setMapOpen,
    setMode,
    create,
    edit,
    handleClose: handleCloseFromParent
  } = props;

  const {
    mapData,
    userListData,
    userListDataError,
    deviceAddedSucess,
    deviceEditedSuccess,
    editError,
    buildingPersonelData,
    customerData,
    error,
  } = useSelector((state) => state.buildingData);

  const dispatch = useDispatch();

  useEffect(() => {
    if(customerData) {
      const selectedCustomer = customerData?.find(
        (customer) => customer.customerId === Number(formData.customerId)
      );
      if(selectedCustomer && selectedCustomer.customerId) {
        dispatch(fetchUsersFromCustomer(selectedCustomer.customerId));
        if(editData && editData.id) {
          dispatch(fetchBuidingPersonnelFromCustomer(editData.id));
        }
      } 
    }
  }, [formData.customerId, customerData, dispatch, editData])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name !== "customerName") {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    setFormLevelError("");
  };
  const requiredFields = ["customerName", "location", "address"];

  const handleValidation = () => {
    let isValid = true;
    let errors = {};
    const fieldLabels = {
      customerName: "customer Name",
    };
    requiredFields.forEach((field) => {
      const value = formData[field];

      if (
        field === "location" &&
        actionButton !== "edit" &&
        (typeof value?.address !== "string" || value.address.trim() === "")
      ) {
        isValid = false;
        errors[field] = "Please select  location";
        return; // skip to next field
      }

      if (
        field !== "location" &&
        (typeof value !== "string" || value.trim() === "")
      ) {
        isValid = false;
        errors[field] = `Please enter ${fieldLabels[field] || field}`;
      }
    });

    setFormError(isValid ? {} : errors);
    return isValid;
  };

  const handleAdd = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formDataToSend = {
      customerName: formData.customerName.substring(0, formData.customerName.lastIndexOf("(")).trim(),
      customerId: formData.customerId,
      location: formData.location.address,
      address: formData.address,
      buildingType: "School",
      latitude: formData.location.lat,
      longitude: formData.location.lng,
      locationUrl: mapData.url,
      buildingPersonnel: formData.buildingPersonnel,
    };
    dispatch(addBuilding(formDataToSend));
  };

  const handleClose = () => {
    setOpen(false);
    setActionButton("");
    setFormError("");
    setFormLevelError("");
    handleCloseFromParent();
    setSuccessMessage(false);
    setFormData({
      customerName: "",
      customerId: "",
      location: "",
      address: "",
      latitude: "",
      longitude: "",
      locationUrl: "",
      buildingPersonnel: []
    });
    dispatch(resestMarkFeild());
    dispatch({ type: "ADD_BUILDING_MODAL_CLEAR" });
    dispatch({ type: "EDIT_BUILDING_MODAL_CLEAR" });
  };

  useEffect(() => {
    if (deviceAddedSucess) {
      setSuccessMessage(true);
    }
  }, [deviceAddedSucess]);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, location: mapData }));
  }, [mapData]);

  const handleEdit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMode("select");
    const useMapData = mapData && Object.keys(mapData).length > 0;
    const formDataToSend = {
      customerName: formData.customerName.substring(0, formData.customerName.lastIndexOf("(")).trim(),
      customerId: parseInt(formData.customerName.substring(formData.customerName.lastIndexOf("(") + 1, formData.customerName.lastIndexOf(")"))),
      location: useMapData ? mapData.address : formData.location,
      address: formData.address,
      buildingType: "School",
      latitude: useMapData ? mapData.lat : formData.latitude,
      longitude: useMapData ? mapData.lng : formData.longitude,
      locationUrl: formData.locationUrl,
      buildingPersonnel: [userGuid, ...(formData?.buildingPersonnel || [])],
    };
    await dispatch(editBuliding(editData.id, formDataToSend));
  };

  useEffect(() => {
    if (deviceEditedSuccess) {
      setSuccessMessage(true);
    }
  }, [deviceEditedSuccess]);

  useEffect(() => {
    if (editError && Object.keys(editError).length > 0) {
      setFormError((prevState) => ({
        ...prevState,
        customerName: editError.customerName || "",
        customerId: editError.customerId || "",
        location: editError.location || "",
        address: editError.address || "",
        latitude: editError.location?.lat,
        longitude: editError.location?.lng,
        locationUrl: editError.url,
        buildingPersonnel: editError.buildingPersonnel,
      }));
    }
  }, [editError]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setFormLevelError("");
    dispatch({type:"DELETE_BUILDING_SUCCESS"})
    dispatch({type:"EDIT_ERROR_CLEAR"})
    if (!handleValidation()) return;
    if (actionButton === "add") {
      handleAdd(e);
    } else if (actionButton === "edit") {
      handleEdit(e);
    }
  };

   useEffect(() => {
    if (deviceAddedSucess || deviceEditedSuccess || error || editError) {
      setIsSubmitting(false);
    }
  }, [deviceAddedSucess, deviceEditedSuccess, error, editError]);
  
  useEffect(() => {
    if (error && typeof error === "string") {
      setFormLevelError(error);
    }
    if(userListDataError && typeof userListDataError === "string") {
      setFormLevelError(userListDataError);
    }
    if (editError && typeof editError === "string") {
      setFormLevelError(editError);
    }
  }, [error, editError, userListDataError]);

  useEffect(() => {
    setFormData((prev) => ({...prev, buildingPersonnel: buildingPersonelData}))
  }, [buildingPersonelData]);

  useEffect(() => {
    if (actionButton === "edit" && editData) {
      setFormData({
        customerName: `${editData.customerName} (${editData.customerId})`,
        customerId: editData.customerId,
        location: editData.location || editData.address,
        address: editData.address,
        latitude: editData.latitude,
        longitude: editData.longitude,
        locationUrl: editData.locationUrl,
        // buildingPersonnel: buildingPersonelData,
      });
    } else {
      setFormData({
        customerName: "",
        customerId: "",
        location: "",
        address: "",
        latitude: "",
        longitude: "",
        locationUrl: "",
        buildingPersonnel: [],
      });
    }
  }, [actionButton, editData]);

  useEffect(() => {
    if(create || edit) {
      dispatch(customerDataAction());
    }
  }, [create, edit, dispatch]);

  const firstInputRef = useRef(null);

  useEffect(() => {
      const timeoutId = setTimeout(() => {
        if (open && firstInputRef.current) {
          firstInputRef.current.focus();
        }
      }, 200);
      return () => {
        clearTimeout(timeoutId);
      };
    }, [open]);


    useEffect(() => {
      if (successMessage) {
        if (open && firstInputRef.current) {
          firstInputRef.current.focus();
        }
      }
    }, [successMessage]);

    return (
      <Modal
        open={open}
        aria-labelledby="add-edit-building-title"
        aria-modal="true"
        onClose={(event, reason) => {
          if (reason === "escapeKeyDown") {
            if (tooltipOpen) {
              setTooltipOpen(false);
            } else {
              handleClose();
            }
          } else if (reason === "backdropClick") {
            return;
          }
        }}
        className={`globalForm ${successMessage ? "userSuccessAdded" : ""}`}
      >
        <div role="none">
          <Box
            role="dialog"
            aria-modal="true"
            sx={style}
            aria-labelledby="add-edit-building-title"
            className="mainModalBox addeditBuilding"
          >
            <span aria-live="polite" className="sr-only" data-testId="errors">
              {Object.values(formError).filter(Boolean).join(", ")}
            </span>
            <div
              className="Modal_header"
              style={
                successMessage
                  ? {
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "15px",
                    }
                  : {}
              }
            >
              {!successMessage && (
                <h1 id="add-edit-building-title">{actionButton === "edit" ? "Edit Building" : "Add Building"}</h1>
              )}
              <AccessibleTooltip title="Close" open={tooltipOpen} customclass={successMessage ? "modalcloseTooltip sucessModaltooltip" :"modalcloseTooltip"}>
                <button
                  ref={firstInputRef}
                  onClick={() => handleClose()}
                  className={"close_button_modal"}
                  aria-label="Close"
                  onFocus={() => setTooltipOpen(true)}
                  onBlur={() => setTooltipOpen(false)}
                  onMouseEnter={() => setTooltipOpen(true)}
                  onMouseLeave={() => setTooltipOpen(false)}
                >
                  <img src={closeIcon} alt="" aria-hidden="true" />
                </button>
              </AccessibleTooltip>
            </div>
  
            <div className="Modal_middle" id="add-edit-user-description">
              {!successMessage ? (
                <Box component="form" noValidate autoComplete="off" className="">
                  {fieldUser.map((data) => {
                    const isInput = data.type === "input";
                    const isSelectable =
                      data.type === "select" &&
                      (actionButton !== "add" || data.name !== "status");
  
                    if (isInput) {
                      return (
                        <TextField
                          key={data.id || data.name}
                          id={data.id}
                          onClick={
                            data.name === "location"
                              ? () => setMapOpen(true)
                              : undefined
                          }
                          slotProps={{
                            "aria-describedby": `${data.id}-helper-text`,
                          }}
                          data-testid={data.id}
                          name={data.name}
                          label={data.label}
                          variant="outlined"
                          onChange={handleInputChange}
                          // value={ data.name === "location" ? actionButton === "edit" ? formData[data.name] : formData[data.name]?.fullDetails?.formatted_address : formData[data.name] || ""}
                          value={
                            data.name === "location"
                              ? actionButton === "edit"
                                ? typeof formData.location === "string"
                                  ? formData.location
                                  : formData.location?.fullDetails?.formatted_address ||
                                    formData.location?.address ||
                                    ""
                                : formData.location?.fullDetails?.formatted_address ||
                                  formData.location?.address ||
                                  ""
                              : formData[data.name] || ""
                          }
                          error={!!formError[data.name]}
                          className="innerFields"
                          helperText={formError[data.name] || data.helperText}
                          fullWidth
                          sx={{
                            "& .MuiInputLabel-root": {
                              transform: "inherit",
                            },
                          }}
                        />
                      );
                    }
                    if (isSelectable) {
                      return (
                        <FormControl
                          key={data.id || data.name}
                          fullWidth
                          className="innerFields"
                        >
                          <InputLabel
                            variant="standard"
                            htmlFor={data.id}
                            shrink={false}
                            className="dropDownLabel"
                          >
                            {data.label}
                          </InputLabel>
                          <ComboBox
                            label="Select Customer"
                            options={Array.isArray(customerData) ? customerData.map(
                              (customer) => `${customer.firstName.trim()} ${customer.lastName.trim()} (${customer.customerId})`
                            ) : []}
                            value={formData.customerName}
                            disabled={actionButton === "edit"}
                            onChange={(value) => {
                              const selectedCustomer = customerData.find(
                                (customer) =>
                                  `${customer.firstName.trim()} ${customer.lastName.trim()} (${customer.customerId})` === value
                              );
                              setFormData((prev) => ({
                                ...prev,
                                customerName: value,
                                customerId: selectedCustomer?.customerId || "",
                              }));
                            }}
                            classes="customCombo"
                          />
                          <FormHelperText id={`${data.id}-helper-text`}>
                            {formError[data.name]}
                          </FormHelperText>
                        </FormControl>
                      );
                    }
                    return null;
                  })}
                 {actionButton === "edit" && (
                  <FormControl key="building-personnel" className="innerFields" fullWidth>
                    <InputLabel
                      id="building-personnel-label"
                      data-testid="building-personnel-header"
                    >
                      Building Personnel
                    </InputLabel>
                    <ComboBoxMultiSelect
                      label="Building Personnel"
                      options={userListData?.filter((user) => user.userGuid !== userGuid).map((user) => ({
                        key: user.userGuid,
                        value: `${user.firstName} ${user.lastName}`,
                      })) || []}
                      value={formData.buildingPersonnel}
                      handleChange={(selectedGuids) => {
                        setFormData((prev) => ({
                          ...prev,
                          buildingPersonnel: selectedGuids,
                        }));
                      }}
                    />
                    <FormHelperText id="building-personnel-helper-text">
                      {formError.buildingPersonnel}
                    </FormHelperText>
                  </FormControl>
                )}
                </Box>
              ) : (
                <div
                  className="emailsent-wrapper manageUser_details"
                  role="alert"
                  aria-live="polite"
                >
                  <img src={checkImg} alt="" aria-hidden="true" />
                  <h2>Success</h2>
                  <p>
                    Building has {actionButton === "add" ? "created" : "updated"}{" "}
                    successfully.
                  </p>
                  <span className="returnUser">
                    Return to{" "}
                    <button
                      type="button"
                      className="btnSubmit mu_back"
                      onClick={() => handleClose()}
                      aria-label="Return to Building Management"
                    >
                      Building Management
                    </button>
                  </span>
                </div>
              )}
            </div>
  
            <div className="Modal_footer">
              {!successMessage && (
                <Box sx={{ display: "flex" }}>
                  <Button
                    variant="contained"
                    className="saveBtn"
                    type="submit"
                    onClick={(e) => handleSubmit(e)}
                    disabled={isSubmitting}
                    aria-label="Save"
                  >
                    Save
                  </Button>
                </Box>
              )}
            </div>
          </Box>
        </div>
      </Modal>
    );
};

AddEditBuilding.propTypes = {
  setOpen: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  create: PropTypes.bool.isRequired,
  edit: PropTypes.bool.isRequired,
  actionButton: PropTypes.string.isRequired,
  setActionButton: PropTypes.func.isRequired,
  editData: PropTypes.object,
  setMapOpen: PropTypes.func.isRequired,
  setMode: PropTypes.func.isRequired,
};
export default AddEditBuilding;
